export const ROUTE_MAP: Record<string, {url: string, operationKlass: string}> = {
  'Admin::User': {
    url: '/users', 
    operationKlass: 'Admin::Users::Show'
  },
  'Establishment::Company': {
    url: '/establishments', 
    operationKlass: 'Admin::Establishment::Companies::Show'
  },
}